import utils from 'utils'
export default class buildTaskDataFilterModal {
    constructor($scope, $uibModalInstance, items1, logger, httpRequest) {
        const typecodeArrStr = '["zzs_declareType"]'
        httpRequest.get_dictByTypeArr(typecodeArrStr).then((res) => {
            $scope.dictData = res.data.value
        })
        $scope.submit = items1.submit
        $scope.result = items1.result

        $scope.cancel = function cancel() {
            $uibModalInstance.dismiss('cancel')
        }
        $scope.ok = function ok() {
            // if (!$scope.checkInfo()) {
            //     return
            // }
            // if (!$scope.checkTypeCycle($scope.submit)) {
            //     return
            // }
            if (!$scope.result.openList.length) return logger.logError('无有效数据可以提交生成任务')
            $scope.submit.taxId = $scope.result.openList.map((ele) => ele.taxId)
            submit()
            //检查申报任务，是否开启了相应的税种
            //当前申报税种类  $scope.submit.sign
            // 勾选数据   $scope.selectedRows
            // httpRequest.checkDataApi().then((res) => {
            //     if (errorList) {
            //         const modalBuildTask = $uibModal.open({
            //             template: buildTaskDataFilterModal,
            //             controller: 'buildTaskDataFilterModal',
            //             backdrop: 'static',
            //             openedClass: 'mod-modal mod-modal-lg',
            //             bindToController: true,
            //             resolve: {
            //                 items1() {
            //                     return $scope.dictData.zzs_declareType
            //                 },
            //             },
            //         })
            //         modalBuildTask.result.then(
            //             () => {
            //                 queryParamInfo()
            //             },
            //             () => {}
            //         )
            //     } else {
            //         submit()
            //     }
            // })
        }
        // 确定提交
        function submit() {
            utils.loading('请求已发送...')
            httpRequest.post_syncInvoice($scope.submit).then((res) => {
                utils.loaded()
                logger.logSuccess('生成申报任务')
                $uibModalInstance.close()
            })
        }
    }
}
buildTaskDataFilterModal.$inject = ['$scope', '$uibModalInstance', 'items1', 'logger', 'httpRequest']



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/taxDeclarationConfig/buildTaskDataFilterModal.js